// extracted by mini-css-extract-plugin
export default {"container":"ItemsAndModsPage_container__PSh77"};